//艺术家主页
export default {
    count:0,
    data:[],
    title:''
}